import { QuestionnaireResponseItem } from '@medplum/fhirtypes'
import { AdapterOptions } from '../../../../../adapters/types'
import { RocFormData } from '../../../../types/RocFormData'
import { RocFormField } from '../../../../types/RocFormField'
import { RocAssessmentQuestionnaireItem } from '../../../../types/questionnaire'
import { getAnswerValuesFromItems } from '../../../../../helpers'
import { BaseSubsectionAdapter } from '../../../../../adapters/BaseSubsectionAdapter'
import { FlatAnswerMutation } from '../../../../../adapters/types'

/**
 * History subsection adapter
 * Handles 60-day history tracking and medical/surgical history (14 fields)
 */
export class HistoryAdapter extends BaseSubsectionAdapter<RocFormData> {
  extractFormData(
    flatAnswers: Record<string, QuestionnaireResponseItem>,
    _options?: AdapterOptions
  ): Partial<RocFormData> {
    const flatAnswersArray = Object.values(flatAnswers)

    // Other history fields
    const functionalLimitations = getAnswerValuesFromItems(
      flatAnswersArray,
      RocAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_HISTORY_FUNCTIONAL_LIMITATIONS
    )

    const activitiesPermitted = getAnswerValuesFromItems(
      flatAnswersArray,
      RocAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_HISTORY_ACTIVITIES_PERMITTED
    )

    const medicalHistory = getAnswerValuesFromItems(
      flatAnswersArray,
      RocAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_HISTORY_MEDICAL_HISTORY
    )?.at(0)

    const surgicalHistory = getAnswerValuesFromItems(
      flatAnswersArray,
      RocAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_HISTORY_SURGICAL_HISTORY
    )?.at(0)

    return {
      [RocFormField.HISTORY_FUNCTIONAL_LIMITATIONS]: functionalLimitations,
      [RocFormField.HISTORY_ACTIVITIES_PERMITTED]: activitiesPermitted,
      [RocFormField.HISTORY_MEDICAL_HISTORY]: medicalHistory,
      [RocFormField.HISTORY_SURGICAL_HISTORY]: surgicalHistory
    }
  }

  buildFlatAnswers(): FlatAnswerMutation[] {
    const mutations: FlatAnswerMutation[] = []

    if (this.formDataFieldExists(RocFormField.HISTORY_FUNCTIONAL_LIMITATIONS)) {
      mutations.push({
        linkId: RocAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_HISTORY_FUNCTIONAL_LIMITATIONS,
        value: this.getFormDataField(RocFormField.HISTORY_FUNCTIONAL_LIMITATIONS)
      })
    }

    if (this.formDataFieldExists(RocFormField.HISTORY_ACTIVITIES_PERMITTED)) {
      mutations.push({
        linkId: RocAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_HISTORY_ACTIVITIES_PERMITTED,
        value: this.getFormDataField(RocFormField.HISTORY_ACTIVITIES_PERMITTED)
      })
    }

    if (this.formDataFieldExists(RocFormField.HISTORY_MEDICAL_HISTORY)) {
      mutations.push({
        linkId: RocAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_HISTORY_MEDICAL_HISTORY,
        value: this.getFormDataField(RocFormField.HISTORY_MEDICAL_HISTORY)
      })
    }

    if (this.formDataFieldExists(RocFormField.HISTORY_SURGICAL_HISTORY)) {
      mutations.push({
        linkId: RocAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_HISTORY_SURGICAL_HISTORY,
        value: this.getFormDataField(RocFormField.HISTORY_SURGICAL_HISTORY)
      })
    }

    return mutations
  }
}
